import React from "react";
import cx from "classnames";
import MainContainer from "../MainContainer";
import styles from "./Footer.module.scss";
import { THandleLinkClick } from "../../../../helpers";
import wfLogo from "../../../../assets/images/wf-logo.svg";

interface Contact {
  recipient: string;
  title: string;
}

interface NavigationItem {
  id: string;
  url: string;
  title: string;
  target?: string;
  isInternalLink?: boolean;
}

interface Menu {
  contact: Contact;
  navigation: NavigationItem[];
}

interface FooterProps {
  className?: string;
  menu: Menu;
  handleLinkClick?: THandleLinkClick;
  homeUrl?: string;
  translate?: (key: string) => string;
}

const Footer: React.FC<FooterProps> = ({
 className = "",
 handleLinkClick = () => {},
 homeUrl = "/",
 translate = null, // Note: If `translate` should return `string`, consider a default function that returns an empty string or the key itself.
 menu,
}) => {
  const { navigation, contact } = menu;

  return (
    <footer className={cx(className, styles.footerMain)}>
      <MainContainer>
        <div className={styles.footerContent}>
          <nav className={styles.navigationBar}>
            <a
              className={styles.footerLink}
              href={homeUrl}
              onClick={event => handleLinkClick(event, homeUrl, "_self", true)}
            >
              {translate && translate("Home")}
              {!translate && "Home"}
            </a>
            {contact && (
              <a
                className={styles.footerLink}
                href={`mailTo:${contact.recipient}`}
                onClick={event => handleLinkClick(event, `mailTo:${contact.recipient}`)}
              >
                {contact.title}
              </a>
            )}
            {navigation.map(n => {
              const { id, title, url, isInternalLink, target } = n;
              return (
                <a
                  key={id}
                  className={styles.footerLink}
                  href={url}
                  target={target}
                  onClick={event => handleLinkClick(event, url, target ?? "_blank", !!isInternalLink)}
                >
                  {title}
                </a>
              );
            })}
          </nav>
          <a href="https://webbfontaine.com" className={styles.logoBox}>
            <img src={wfLogo} alt="Webb Fontaine LLC" />
          </a>
        </div>
      </MainContainer>
    </footer>
  );
};

export default Footer;
